import { createFileRoute } from '@tanstack/react-router';
import { SalesReport } from '../../../features/reports/screens/SalesReport';

export interface SalesReportSearch {
  customerId?: string;
}

/** Owned by G25. Report #7 — sales by customer/product/period. Accepts an
 * optional `?customerId=` deep link from global search (a CUSTOMER match). */
export const Route = createFileRoute('/_authenticated/reports/sales')({
  validateSearch: (search: Record<string, unknown>): SalesReportSearch => ({
    customerId: typeof search.customerId === 'string' ? search.customerId : undefined,
  }),
  component: SalesReportRoute,
});

function SalesReportRoute() {
  const { customerId } = Route.useSearch();
  return <SalesReport initialCustomerId={customerId} />;
}
